import React from 'react';
import { CheckIcon, FlameIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { MOCKUP_URL, bonuses, volumes } from '../../data/content';
const SPOTS_LEFT = 7;
const FILLED = 94;
export function Offer() {
  return <section id="offer" className="w-full bg-navy px-4 py-16 sm:px-5 sm:py-20" data-id="element-224" data-mp="357f35qzi2b8c">
      <div className="mx-auto max-w-2xl" data-id="element-225" data-mp="3a5yts4p1gb71">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-226" data-mp="3a4xd9kp96whx">
          Get the Complete Pediatric Motor Planning System
        </h2>
        <p className="mt-3 text-center text-white/75" data-id="element-227" data-mp="3jwjmjbi16li1">Everything in one digital professional toolkit.</p>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-2xl ring-4 ring-accent" data-id="element-228" data-mp="3nwbzs1iddftq">
          <div className="bg-accent py-2.5 text-center text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-229" data-mp="3sxhta1jut74b">Your Complete Digital Package</div>
          <div className="p-5 sm:p-8" data-id="element-230" data-mp="1kl89kvaivda9">
            <img src={MOCKUP_URL} alt="Complete Pediatric Motor Planning Blueprint package" className="mx-auto w-full" data-id="element-231" data-mp="1km9iou7z9ppc" />

            <p className="mt-6 text-xs font-extrabold uppercase tracking-wider text-brand" data-id="element-232" data-mp="1fl2cgzlhgyks">The 6 core volumes</p>
            <ul className="mt-2 space-y-2" data-id="element-233" data-mp="1bmmu590ckedp">
              {volumes.map((v, i) => <li key={v.title} className="flex gap-2 text-[15px] text-navy" data-id="element-234" data-mp="16njq9rw3se7b" data-mpi={i}>
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-235" data-mp="23bg6uwrjj9ij" />
                  <span data-id="element-236" data-mp="1zbnxwiy8j1cn"><strong data-id="element-237" data-mp="1zaw8xqz581vc">Volume 0{i + 1}</strong> — {v.title}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-xs font-extrabold uppercase tracking-wider text-accent-dark" data-id="element-238" data-mp="1uhjlhk67a146">Plus all 5 complementary bonuses</p>
            <ul className="mt-2 space-y-2" data-id="element-239" data-mp="2n0gu8girrb7s">
              {bonuses.map(b => <li key={b.title} className="flex gap-2 text-[15px] text-navy" data-id="element-240" data-mp="2i98mrq101zx9">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-241" data-mp="2i75luayb6mdr" />
                  {b.title}
                </li>)}
            </ul>

            <div className="mt-8 text-center" data-id="element-242" data-mp="364290hbq2noa">
              <p className="text-sm font-bold uppercase tracking-wider text-navy/60" data-id="element-243" data-mp="2sdf5mbv0o9lv">Only</p>
              <p className="font-display text-7xl font-extrabold leading-none text-brand" data-id="element-244" data-mp="2weinf3wmkfpq">
                $27<span className="ml-1 text-2xl text-navy" data-id="element-245" data-mp="2iezggefjvaf0">USD</span>
              </p>
              <p className="mt-2 font-semibold text-navy" data-id="element-246" data-mp="2ihc85jb40z59">One-Time Payment · No Subscription · Instant Digital Access</p>
              <p className="mx-auto mt-3 flex w-fit items-center gap-2 rounded-full bg-brand-light px-3 py-1.5 text-[13px] font-semibold text-brand-dark" data-id="element-247" data-mp="29ektzbqunp9x">
                <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="2dg6dhfxw31t3" />
                Currency is converted automatically to your local currency
              </p>
            </div>

            <div className="mt-6 rounded-2xl border-2 border-danger/30 bg-danger-light p-4" data-id="element-249" data-mp="bn8et3hflf08">
              <p className="flex items-center justify-between gap-2 text-sm font-extrabold text-danger" data-id="element-250" data-mp="1w7lve16es0go">
                <span className="flex items-center gap-1.5" data-id="element-251" data-mp="1s6a3fp02b35b">
                  <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="25w3umdz1hzi7" /> High demand
                </span>
                <span data-id="element-253" data-mp="2155af3axkh9o">Only {SPOTS_LEFT} spots left</span>
              </p>
              <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} data-id="element-254" data-mp="213u52z1u71gg">
                <div className="h-full rounded-full bg-danger" style={{
                width: `${FILLED}%`
              }} data-id="element-255" data-mp="2auyl82390scv" />
              </div>
              <p className="mt-2 text-center text-[13px] font-semibold text-navy" data-id="element-256" data-mp="2ot5c2y9s5s31">
                {SPOTS_LEFT} spots remaining at the $27 promotional price
              </p>
            </div>

            <div className="mt-6 flex flex-col items-center gap-4" data-id="element-257" data-mp="uhgs2hooyzbs">
              <CTAButton label="Yes! I Want My Complete System" sublabel="Get instant access — only $27" data-id="element-258" data-mp="pj6w44v57up4" />
              <Countdown data-id="element-259" data-mp="rw0npe5r5olf" />
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-2 text-[13px] font-semibold text-navy" data-id="element-260" data-mp="rz53l8sky8rx">
              {['6 Practical Volumes', '5 Complementary Bonuses', 'Downloadable Digital Resources', '7-Day Money-Back Guarantee'].map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-261" data-mp="15wtilzzyulp2">
                  <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-262" data-mp="88tbnn030vai" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}